import React from "react";
import { ServicePlanSlide } from "../../pages/onboarding/servicePlanSlide/ServicePlanSlide";

export const AllServicePlanComponent: React.FC = () => {
  return (
    <div>
      <ServicePlanSlide />
    </div>
  );
};
